import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/feature/PageMeta';

export default function NotFound() {
  return (
    <>
      <PageMeta title="找不到頁面｜複刻文化 Fuko" description="找不到指定的頁面。" noIndex />
      <Navbar />
      <main className="pt-20 min-h-[70vh] flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="font-mono text-sm text-foreground-400 tracking-widest mb-4">404</div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">找不到頁面</h1>
          <p className="text-sm text-foreground-500 leading-relaxed mb-8">
            您要找的頁面不存在、已移除或網址有誤。請確認網址，或返回首頁重新瀏覽。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
            >
              返回首頁<i className="ri-home-4-line"></i>
            </Link>
            <Link
              to="/books"
              className="inline-flex items-center justify-center gap-2 px-6 py-2.5 border border-background-300 text-foreground-700 font-medium rounded-md hover:bg-background-100 transition-colors whitespace-nowrap text-sm"
            >
              瀏覽書籍<i className="ri-book-2-line"></i>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}